<template>
  <section>
    <table :class="`voucher-table combine-type cols-${colCount}`">
      <caption>
        더블 이용권 표
      </caption>
      <colgroup>
        <col style="width: 230px" />
        <col
          v-for="(_, index) in colCount"
          :key="index"
          :style="{ width: 100 / colCount + '%' }"
        />
      </colgroup>
      <thead>
        <tr>
          <th>
            <div v-if="showAllVoucherState">
              <span class="emphasis">이용권 구독</span>
              <span><strong>[모든 이용권 보기]</strong>&nbsp;버튼을</span>
              <span>선택하여 전체 이용권 정보를</span>
              <span>확인하세요</span>
            </div>
            <span class="a11y-hidden">이용권 상품 목록 (더블 이용권)</span>
          </th>
          <th
            v-for="(voucher, thIndex) in getFilteredVoucherList(
              voucherList,
              'main-voucher',
            )"
            :key="`voucher_head__${thIndex}`"
            scope="col"
          >
            <VoucherTableHead
              :key="`${voucher.quality_name}__${thIndex}`"
              :voucher="voucher"
              :selected-product="selectedProduct"
              @on-click-product="onClickProduct"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <VoucherTableRow
          v-for="(voucher, trIndex) in voucherTableList(
            getFilteredVoucherList(voucherList, 'main-voucher'),
            bodyDescriptionList,
          )"
          :key="`tr__${trIndex}__${voucher.title}`"
          :voucher="voucher"
        />
      </tbody>
    </table>
    <div v-if="showAllVoucherState" class="voucher-more-wrap">
      <button type="button" class="voucher-more-btn" @click="clickMoreVoucher">
        모든 이용권 보기
      </button>
    </div>
    <div class="partner-benefit-box">
      <strong class="title">더블 이용권 공통혜택</strong>
      <div class="box">
        <dl
          v-for="benefit in VOUCHER_INTEGRATED_BENEFITS"
          :key="benefit?.title"
        >
          <dt>{{ benefit?.title }}</dt>
          <dd
            v-for="(item, index) in benefit?.benefits"
            :key="index"
            v-html="item"
          ></dd>
        </dl>
      </div>
    </div>
  </section>
</template>
<script setup>
  import { computed, defineProps, defineEmits } from 'vue'
  import { useVoucherTable } from '@/common/use/useVoucherTable'
  import VoucherTableHead from '@/components/voucher/VoucherTableHead.vue'
  import VoucherTableRow from '@/components/voucher/VoucherTableRow.vue'
  import { VOUCHER_INTEGRATED_BENEFITS } from '@/components/voucher/partner/const'

  const {
    selectedProduct,
    refinePurchasePayload,
    getVoucherTableRow,
    voucherTableList,
  } = useVoucherTable()

  const props = defineProps({
    voucherPurchaseFn: {
      type: Function,
      default: () => {},
    },
    voucherList: {
      type: Array,
      default: () => [],
    },
    bodyDescriptionList: {
      type: Array,
      default: () => [],
    },
    showAllVoucherState: {
      type: Boolean,
      default: true,
    },
    getFilteredVoucherList: {
      type: Function,
      default: () => [],
    },
  })
  const emit = defineEmits(['show-voucher'])
  const colCount = computed(
    () =>
      props.getFilteredVoucherList(props.voucherList, 'main-voucher').length,
  )
  const onClickProduct = (voucher, product) => {
    const payload = refinePurchasePayload(voucher, product)

    return props.voucherPurchaseFn(payload)
  }

  const init = () =>
    getVoucherTableRow(props.voucherList, props.bodyDescriptionList)

  const clickMoreVoucher = () => {
    emit('show-voucher')
  }

  init()
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
<style lang="scss" scoped>
  .partner {
    &-benefit-box {
      margin-top: 20px;
      padding: 36px 40px;
      border: 1px solid #252525;
      border-radius: 8px;
      .title {
        font-size: 20px;
        line-height: 28px;
        font-weight: normal;
      }
      .box {
        margin-top: 20px;
        display: flex;
        > dl {
          width: 100%;
          dt {
            font-size: 14px;
            line-height: 20px;
            font-weight: bold;
          }
          dd {
            position: relative;
            margin-top: 8px;
            padding-left: 28px;
            font-size: 14px;
            line-height: 20px;
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 20px;
              height: 20px;
              background: url(~@/assets/images/common/ico-check-gray.png)
                no-repeat center / cover;
            }
          }
        }
      }
    }
  }
</style>
